/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode, miniSidenav } = ownerState;

  const { white, transparent, dark, grey } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem, rgba } = functions;

  return {
    background: () => {
      let backgroundValue = transparent.main;
      if (active) {
        if (darkMode) {
          backgroundValue = rgba(white.main, 0.1);
        } else {
          backgroundValue = rgba(dark.main, 0.08);
        }
      }
      return backgroundValue;
    },
    color: (transparentSidenav || whiteSidenav) && !darkMode ? dark.main : white.main,
    display: "flex",
    alignItems: "center",
    justifyContent: miniSidenav ? "center" : "flex-start",
    width: "100%",
    padding: `${pxToRem(2)} ${pxToRem(12)}`,
    margin: 0,
    borderRadius: "6px",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "none",
    border: "none",
    [breakpoints.up("xl")]: {
      padding: miniSidenav ? `${pxToRem(2)} ${pxToRem(0)}` : `${pxToRem(2)} ${pxToRem(12)}`,
      transition: transitions.create(["background-color", "padding"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: !active ? (darkMode ? rgba(white.main, 0.05) : rgba(dark.main, 0.04)) : undefined,
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, borders, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode } = ownerState;

  const { white, dark } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(32),
    minHeight: pxToRem(28),
    color: (transparentSidenav || whiteSidenav) && !darkMode ? dark.main : white.main,
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: (transparentSidenav || whiteSidenav) && !darkMode ? dark.main : white.main,
    },
  };
}

// Selo colorido da seção: o fundo do menu é marrom (#a86b32) e só tons quase brancos teriam contraste
// direto nele, então a cor vai no fundo do selo e o ícone fica branco (contraste >= 4,5:1).
function collapseIconSelo(theme, ownerState) {
  const { functions } = theme;
  const { iconColor } = ownerState;
  const { pxToRem } = functions;

  return {
    width: pxToRem(26),
    height: pxToRem(26),
    borderRadius: "7px",
    backgroundColor: iconColor,
    display: "grid",
    placeItems: "center",
    color: "#fff",

    "& .MuiIcon-root, & svg": {
      color: "#fff !important",
      fontSize: `${pxToRem(17)} !important`,
    },
  };
}

const collapseIcon = ({ palette: { white, gradients, dark } }, { active, whiteSidenav, transparentSidenav, darkMode }) => ({
  color: active ? ((whiteSidenav || transparentSidenav) && !darkMode ? dark.main : white.main) : gradients.dark.state,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightRegular, fontWeightLight } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(10),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(10),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightRegular : fontWeightLight,
      fontSize: size.sm,
      lineHeight: 0,
    },
  };
}

function collapseArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme;
  const { noCollapse, transparentSidenav, whiteSidenav, miniSidenav, open, active, darkMode } =
    ownerState;

  const { white, dark } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: () => {
      let colorValue;

      if (transparentSidenav && darkMode) {
        colorValue = open || active ? white.main : rgba(white.main, 0.25);
      } else if (transparentSidenav || whiteSidenav) {
        colorValue = open || active ? dark.main : rgba(dark.main, 0.25);
      } else {
        colorValue = open || active ? white.main : rgba(white.main, 0.5);
      }

      return colorValue;
    },
    transition: transitions.create(["color", "transform", "opacity"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    display: noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
      ? "none !important"
      : "block !important",
  };
}

export { collapseArrow, collapseIcon, collapseIconBox, collapseIconSelo, collapseItem, collapseText };

